// /var/www/oszczedzam/client/src/components/budgets/BudgetForm.js
import React, { useState } from 'react';
import { 
  Box, Button, TextField, FormControl, InputLabel, 
  Select, MenuItem, Grid, Paper, Typography 
} from '@mui/material';

// Kategorie wydatków
const expenseCategories = [
  'Mieszkanie', 'Transport', 'Żywność', 'Rozrywka', 'Zdrowie', 
  'Odzież', 'Edukacja', 'Prezenty', 'Podróże', 'Inne'
];

function BudgetForm({ onSubmit, initialData, isEditing = false }) {
  const [category, setCategory] = useState(initialData?.category || '');
  const [limit, setLimit] = useState(initialData?.limit || '');
  const [period, setPeriod] = useState(initialData?.period || 'monthly');
  const [errors, setErrors] = useState({});

  // Walidacja formularza
  const validateForm = () => {
    const newErrors = {};
    
    if (!category) newErrors.category = 'Kategoria jest wymagana';
    if (!limit || isNaN(limit) || parseFloat(limit) <= 0) {
      newErrors.limit = 'Limit musi być większy od zera';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Obsługa zatwierdzania formularza
  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!validateForm()) return;
    
    // Przygotuj dane budżetu
    const budgetData = {
      category,
      limit: parseFloat(limit),
      period
    };
    
    // Wywołaj funkcję przekazaną przez props
    onSubmit(budgetData);
  };

  return (
    <Paper elevation={3} sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom>
        {isEditing ? 'Edytuj budżet' : 'Nowy budżet'}
      </Typography>
      
      <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 2 }}>
        <Grid container spacing={2}>
          {/* Kategoria */}
          <Grid item xs={12}>
            <FormControl fullWidth required error={!!errors.category}>
              <InputLabel id="category-label">Kategoria</InputLabel>
              <Select
                labelId="category-label"
                id="category"
                value={category}
                label="Kategoria"
                onChange={(e) => setCategory(e.target.value)}
                disabled={isEditing} // Nie pozwól na zmianę kategorii podczas edycji
              >
                {expenseCategories.map((cat) => (
                  <MenuItem key={cat} value={cat}>{cat}</MenuItem>
                ))}
              </Select>
              {errors.category && <Typography color="error" variant="caption">{errors.category}</Typography>}
            </FormControl>
          </Grid>
          
          {/* Limit */}
          <Grid item xs={12} sm={6}>
            <TextField
              required
              fullWidth
              id="limit"
              label="Limit budżetu"
              type="number"
              InputProps={{ inputProps: { min: 0, step: 0.01 } }}
              value={limit}
              onChange={(e) => setLimit(e.target.value)}
              error={!!errors.limit}
              helperText={errors.limit}
            />
          </Grid>
          
          {/* Okres */}
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth>
              <InputLabel id="period-label">Okres</InputLabel>
              <Select
                labelId="period-label"
                id="period"
                value={period}
                label="Okres"
                onChange={(e) => setPeriod(e.target.value)}
              >
                <MenuItem value="monthly">Miesięcznie</MenuItem>
                <MenuItem value="weekly">Tygodniowo</MenuItem>
                <MenuItem value="yearly">Rocznie</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          
          {/* Przyciski */}
          <Grid item xs={12} sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
            <Button variant="contained" type="submit">
              {isEditing ? 'Zapisz zmiany' : 'Dodaj budżet'}
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Paper>
  );
}

export default BudgetForm;